import { render, staticRenderFns } from "./ViewHistory.vue?vue&type=template&id=9693d6c4"
import script from "./ViewHistory.vue?vue&type=script&lang=js"
export * from "./ViewHistory.vue?vue&type=script&lang=js"
import style0 from "./ViewHistory.vue?vue&type=style&index=0&id=9693d6c4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports